<template>
    <div v-if="slides[0].length" class="similar-hotels">
        <div class="similar-hotels__title mb-2 font-weight-medium text-truncate">
            {{ title }}
        </div>
        <v-carousel :show-arrows="slides.length > 1" hide-delimiters height="auto">
            <v-carousel-item v-for="(slide, index) in slides" :key="index">
                <v-row>
                    <v-col v-for="hotel in slide" :key="hotel.hotelCode" md="6">
                        <hotel-offer-card
                            :offer="hotel"
                            :search-request="searchRequest"
                            hide-room-offers
                            hide-tripadvisor-rating
                        >
                            <template v-slot="{minPriceRoomOffer, hotelPageLink}">
                                <div class="similar-hotels__btn-wrapper mt-2 full-width text-right">
                                    <v-btn v-if="hotelPageLink" :to="hotelPageLink" color="primary" variant="flat">
                                        <template v-if="isShowPrice(minPriceRoomOffer)">
                                            {{ $filters.price(minPriceRoomOffer.price) }}
                                        </template>
                                        <template v-else>
                                            {{ $t('view') }}
                                        </template>
                                    </v-btn>
                                </div>
                            </template>
                        </hotel-offer-card>
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import HotelOfferCard from '~src/components/search/offers/hotelOfferCard.src'
    import {EventBus, FILTER_EVENT} from '@/utils/event-bus'
    import {searchRequest} from '@/utils/hotels/hotels-blank-states'

    @Component({components: {HotelOfferCard}})
    export class SimilarHotels extends Vue {
        @Prop({required: false, type: Object}) searchRequest
        @Prop({required: false, type: Object}) city

        async mounted() {
            EventBus.$on(FILTER_EVENT, this.filterSimilar)
            await this.$store.restored
            await this.loadOffers()
        }

        beforeUnmount() {
            EventBus.$off(FILTER_EVENT, this.filterSimilar)
        }

        filterSimilar() {
            if (hotelsRuntimeStore.filteredOffers.length) {
                hotelsRuntimeStore.filterSimilar(this.info)
            }
        }

        async loadOffers() {
            if (this.searchRequest.cityId !== hotelsStore.searchRequest.cityId) {
                hotelsRuntimeStore.SET_SIMILAR_OFFERS([])
                const sr = Object.assign(searchRequest(), this.searchRequest)

                delete sr.hotelId
                if (!sr.category) sr.category = hotelsStore.category(this.info.stdCategory)
                await hotelsRuntimeStore.search(sr)

                return
            }
            if (!hotelsRuntimeStore.filteredOffers.length) {
                const offers = await this.$localForage.getItem('hotels')
                if (offers) hotelsRuntimeStore.load(offers)
            } else {
                hotelsRuntimeStore.filterSimilar(this.info)
            }
        }

        isShowPrice(minPriceRoomOffer) {
            return !minPriceRoomOffer?.soldOut
        }

        get hotels() {
            return hotelsRuntimeStore.similarOffers.filter(hotel => hotel.hotelCode !== this.info.hotelCode)
        }

        get slides() {
            let counter = 0
            let index = 0
            let slides = [[]]
            if (this.hotels.length) {
                this.hotels.forEach(hotel => {
                    if (slides.length === 2 && slides[1].length === 2) return false
                    if (counter < 2) {
                        slides[index].push(hotel)
                        counter++
                    } else {
                        counter = 0
                        index++
                        slides[index] = []
                        slides[index].push(hotel)
                    }
                })
            }
            return slides
        }

        get info() {
            return hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo
        }

        get title() {
            return this.$t('similar_hotels')
        }
    }

    export default SimilarHotels
</script>
